export enum MessageCenterListTabEnums {
  INBOX,
  UNREAD,
  SENT,
}

export enum NotificationsColumnEnums {
  SENDER = 'fromUser',
  SUBJECT = 'subject',
  DATE = 'date',
}
